var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cta',{staticClass:"top",attrs:{"is-link":"","size":"L","font-icon":"fn_angleUp","type":"text","content":_vm.config.ctas.top},on:{"click":_vm.scrollToTop}})}
var staticRenderFns = []

export { render, staticRenderFns }